/**
 * Em que pé está a grade horária de uma turma.
 *
 * Lê uma linha de `/class-schedule/summary/` — a grade VIGENTE, e não as
 * aulas previstas no mês. É a diferença que importa: num mês de recesso
 * nenhuma aula é prevista, e contar por aí acusava a rede inteira de estar
 * "sem grade".
 *
 * "Completa" quer dizer que nenhum dia de segunda a sexta ficou sem aula —
 * não que cada dia tem o número certo de aulas, porque isso muda de turma
 * para turma. Por isso a tela mostra as aulas de cada dia ao lado.
 */

// Segunda a sexta, no padrão da API (0 = segunda).
export const DIAS_LETIVOS = [
  { weekday: 0, sigla: 'Seg' },
  { weekday: 1, sigla: 'Ter' },
  { weekday: 2, sigla: 'Qua' },
  { weekday: 3, sigla: 'Qui' },
  { weekday: 4, sigla: 'Sex' },
];

export const SITUACOES_GRADE = {
  completa: {
    rotulo: 'Grade completa',
    dica: 'Todos os dias de segunda a sexta têm aula na grade.',
    numero: 'text-[#13983D]',
  },
  incompleta: {
    rotulo: 'Grade incompleta',
    dica: 'A grade foi começada, mas algum dia de segunda a sexta está sem aula.',
    numero: 'text-[#F9B047]',
  },
  vazia: {
    rotulo: 'Sem grade',
    dica: 'Nenhuma aula na grade vigente — a turma fica fora da cobrança de diários.',
    numero: 'text-[#E83A3C]',
  },
};

/** Aulas da turma num dia da semana (0 = segunda). */
export function aulasNoDia(resumo, weekday) {
  return (resumo?.slots_by_weekday || {})[String(weekday)] || 0;
}

/** 'completa' | 'incompleta' | 'vazia'. Turma fora do resumo não tem grade. */
export function situacaoDaGrade(resumo) {
  if (!resumo || !resumo.total_slots) return 'vazia';
  return DIAS_LETIVOS.every(d => aulasNoDia(resumo, d.weekday) > 0)
    ? 'completa'
    : 'incompleta';
}
